import { IState } from '../../store';

export const getRenterFromState = (state: IState) => {
  return state.renterForm;
};
